<!-- eslint-disable -->
<template lang="pug">
    .todo-banner
        .todo-banner__header
            | {{ $i18n.t('dashboard.dashboard_restriction_user_info') }}
        divider.todo-banner__divider(:margin="'0 auto'")
        template(v-if="!isLoading")
            .todo-banner__body
                .task(
                    v-if="userType === 'teacher' || userType === 'student'"
                )
                    | {{ remainingFreeGameTime }}
                .task(
                    v-if="userType === 'teacher' || userType === 'admin'"
                )
                    div.homework-wrapper
                        span.homework-title {{ $i18n.t('dashboard.dashboard_restriction_homework') }}

                        table.homework-limits-table(
                            v-if="homeworkLimits && homeworkLimits.length"
                        )
                            thead
                                tr
                                    th.col-name {{ $i18n.t('fields.fields_userFirstNameAndLastName') }}
                                    th.col-count {{ $i18n.t('dashboard.dashboard_restriction_rest') }}
                            tbody
                                tr(
                                    v-for="(item, index) in homeworkLimits"
                                    :key="index"
                                )
                                    td.col-name {{ item.userName }}
                                    td.col-count {{ availableHomeworkCount(item.weeklyLimit, item.usedHomework) }}

        cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/

    import { DEFAULT_PLAYTIME_LIMIT } from '@/config/tariff_constants';

    export default {
        props: {
            tariffId: Number,
            userType: String,
            tariffSnapshot: Object,
            homeworkLimits: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                isLoading: false,
                tariff: null,
            }
        },
        methods: {
            availableHomeworkCount(weeklyLimit, usedHomework) {
                const limit = Number(weeklyLimit) || 0;
                const used  = Number(usedHomework) || 0;

                return Math.max(limit - used, 0);
            }
        },
        computed: {
            remainingFreeGameTime() {
                let playTime;
                if (this.tariffSnapshot) {
                    playTime = this.tariffSnapshot.playtime ?? 0;
                } else {
                    playTime = DEFAULT_PLAYTIME_LIMIT;
                }
                return this.$i18n.t('dashboard.dashboard_restriction_free_game_time') +
                ': ' + Math.max(playTime, 0) + ' сек.';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .todo-banner {
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .todo-banner__header {
        margin: 30px 0 25px 30px;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .todo-banner__body {
        margin: 0 30px;
        font-size: 16px;
        line-height: 24px;
    }

    .todo-banner__divider {
        width: calc(100% - 60px) !important;
    }

    .task {
        display: flex;
        align-items: center;
        margin: 20px 0;
    }

    .homework-wrapper {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .homework-title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 4px;
    }

    .homework-limits-table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }

    .homework-limits-table thead th {
        text-align: left;
        font-weight: 700;
        padding: 8px 0;
        font-size: 14px;
    }

    .homework-limits-table tbody td {
        text-align: left;
        padding: 6px 0;
        font-size: 14px;
        vertical-align: top;
    }

    .homework-limits-table tbody tr + tr td {
        border-top: 1px solid #e5e7eb;
    }

    .col-name {
        width: 70%;
        word-break: break-word;
    }

    .col-count {
        width: 30%;
        text-align: left;
    }
</style>
